export enum RoutineOperation {
  READ = 0,
  CREATE = 1,
  UPDATE = 2,
  DELETE = 3,
  UNBLOCK = 5
}
